import i18n from "@/core/plugins/i18n";
const { t, te } = i18n.global;
export const  translate = (text: string, params = null): string => {
  return t(text, params!!);
};